import { styled } from "styled-components";

export const CardHeading = styled.p`
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #505f79;
    margin-bottom: 24px;
`;
